import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import {
  Box,
  Dialog,
  Stack,
  TextField,
  TextLink,
  Button,
  IconLink,
  useDialogController
} from '@machobear/design-system'
import InfoBox from '../../components/info-box'

interface Props {
  listingId: string
  videoType: '2d' | '3d'
  disabled?: boolean
}

const VideoLinkModalBtn = ({ listingId, videoType, disabled }: Props) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { visible, showModal, closeModal } = useDialogController()
  const [url, setUrl] = useState<string>('')

  const onAddVideoLink = async () => {
    try {
      const response = await dispatch.listing.addVideoLink({
        listingId: listingId,
        linkUrl: url.replace(/\/shorts\//, '/embed/'),
        videoType
      })
      if (!response.ok) {
        throw Error('Failed to add video link')
      }
    } catch {
      // error
      return
    }
    closeModal()
    return true
  }

  return (
    <>
      <Button
        icon={<IconLink />}
        variant="ghost"
        size="large"
        onClick={() => {
          showModal()
        }}
        disabled={disabled}
      >
        {t('Link video', 'Link video')}
      </Button>
      <Dialog
        id="listing-video-upload-modal"
        open={visible}
        width="small"
        title="Link video"
        onClose={() => {
          closeModal()
        }}
      >
        <Stack space="xxsmall">
          <TextField
            id={`video-upload-link`}
            label={'Video URL'}
            required
            value={url}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setUrl(e.target.value)}
            placeholder={''}
          />
          <InfoBox paddingTop="xxsmall">
            <Trans i18nKey="l.listing.edit.video_upload_info.text">
              Video providers supported: YouTube and Vimeo. Don’t see yours listed?{' '}
              <TextLink href="mailto:support@liv.rent" target="_blank">
                Contact us
              </TextLink>
            </Trans>
          </InfoBox>
          <Box display="flex" justifyContent="flexEnd" cursor="pointer" marginTop="xxsmall">
            <Box style={{ width: '110px' }}>
              <Button
                size="standard"
                onClick={() => {
                  onAddVideoLink()
                }}
              >
                {t('Add link', 'Add link')}
              </Button>
            </Box>
          </Box>
        </Stack>
      </Dialog>
    </>
  )
}

export default VideoLinkModalBtn
